export { default } from './ReactMarkdown';
